import { render, staticRenderFns } from "./main-header.vue?vue&type=template&id=6e19a37f"
import script from "./main-header.vue?vue&type=script&lang=js"
export * from "./main-header.vue?vue&type=script&lang=js"
import style0 from "./main-header.vue?vue&type=style&index=0&id=6e19a37f&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports